module.exports = {
	"library.footer.terms_of_use": "Gebruiksvoorwaarden",
	"library.footer.terms_and_conditions": "Terms and Conditions",
	"library.footer.privacy_policy": "Privacy policy",
	"library.footer.get_to_know_us": "Leer ons kennen",
	"library.footer.about": "Over ons",
	"library.footer.jobs": "Jobs",
	"library.footer.blog": "Blog",
	"library.footer.get_help": "Help",
	"library.footer.find_events": "Events zoeken",
	"library.footer.top_events": "Top events",
	"library.footer.host_events": "Organiseer events",
	"library.footer.become_a_host": "Word organisator",
	"library.footer.tour": "Rondleiding",
	"library.footer.embeddable_widgets": "plugins",
	"library.footer.customers": "Klanten",
	"library.footer.pricing": "Wat kost het?",
	"library.footer.get_the_onsite_app": "De onsite app installeren",
	"library.footer.developers": "Ontwikkelaars",
	"library.footer.contact_us": "Contact"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/footer/translations/nl-be.json
// module id = 1600
// module chunks = 0 1 2 4 5 6 7 8 9 10 11 12 13 14 15 16